module.exports = __webpack_public_path__ + "img/bubble-hit.29cd1ab1.svg";